import React, { useContext, useEffect, useMemo } from 'react';
import { usePOS } from '../hooks/usePOS';


export const POSContext = React.createContext()

export const POSProvider = ({ children }) => {
    const vendingState = usePOS();
    const value = useMemo(() => vendingState, [vendingState])

    //useEffect(() => { console.log("POSProvider => ", value) }, [value])

    return (
        <POSContext.Provider value={value}>
            {children}
        </POSContext.Provider>
    );
}

export function usePOSContext() {
    return useContext(POSContext)
}
